/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useInvoiceUrl } from 'domain/finance/invoice/shared/useInvoiceRouting';

const InvoiceBreadcrumbs = ({ children }: { children: React.ReactNode }) => {
  const { getListUrl } = useInvoiceUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Invoices" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default InvoiceBreadcrumbs;
